import { render, staticRenderFns } from "./NavbarLinks.vue?vue&type=template&id=82dd1fda&scoped=true&"
import script from "./NavbarLinks.vue?vue&type=script&lang=js&"
export * from "./NavbarLinks.vue?vue&type=script&lang=js&"
import style0 from "./NavbarLinks.vue?vue&type=style&index=0&id=82dd1fda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82dd1fda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VList,VListItem,VListItemContent,VListItemTitle,VSubheader})
